import { Outlet } from "react-router-dom";
import { LayoutContainer, ContentContainer } from "./DefaultLayoutStyles";
import LoggedHeader from "../components/loggedHeader/LoggedHeader";
import Footer from "../components/footer/Footer";
import WavesBackground from "../components/wavesBackground/WavesBackground";

const LoggedLayout = () => {
  return (
    <LayoutContainer>
      <LoggedHeader />
      <WavesBackground />
      <ContentContainer>
        <Outlet />
      </ContentContainer>
      <Footer />
    </LayoutContainer>
  );
};

export default LoggedLayout;
